<template>
<div>
  <div class='employee-card'>
    <div class='employee-card-divider-header' />
    <div class='fl'>
      <div>
        <person-portrait :firstName="employee.initials" :lastName='employee.lastName' :scale="1"/>
      </div>
      <div style='margin-left: 22px;'>
        <h2 style='position: relative; top: -6px; font-size: 1.1em; letter-spacing: 0.2px;'>{{ employee.getFullName() }}</h2>

        <table class='mb-2 mt-3'>
          <tr>
            <td style='padding-right: 25px;'>
              <p class='label'>{{ 'employee.id-abrev' | translate }}</p>
              <p class='value'>{{ employee.employeeNumber }}</p>
            </td>
            <td style='padding-right: 25px;'>
              <p class='label'>{{ 'employee.date-of-birth' | translate }}</p>
              <p class='value'>{{ getFormattedDate(employee.dateOfBirth) }}</p>
            </td>
            <td>
              <p class='label'>{{ 'employee.gender' | translate }}</p>
              <p class='value'>{{ this.employee.gender | translate }}</p>
            </td>
          </tr>
        </table>
        <table v-if="showPolicies" class='hf'>
          <tr >
            <td class='hf'>
              <p class='label'> {{ 'policies.policies-with-coverage' | translate }} </p>
              <ul v-if="policiesWithCoverage && policiesWithCoverage.length > 0" style='padding-left: 0;'>
                <li v-for="policy in policiesWithCoverage" :key="policy.product.id+'-indicator-coverage'" class='value'>{{ policy.product.description }}</li>
              </ul>
              <p v-else class='value light'>Geen polissen met dekking gevonden voor {{getFormattedDate(this.policyCoverageDate)}}</p>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Helpers from '@/shared/helpers/functions';
import Compositions from '@/views/helpers/compositions';
import PersonPortrait from '@aevitae/aevitaeui/0_atoms/containers/PersonPortrait.vue';

export default {
  name: 'EmployeeCard',
  props: {
    employee: Object,
    showPolicies: Boolean,
    light: Boolean,
    policyCoverageDate: {
      type: null,
      default: new Date().toString().substr(0, 9)
    }
  },
  components: {
    PersonPortrait
  },
  computed: {
    policiesWithCoverage () {
      if (this.showPolicies) {
        return Compositions.getPoliciesFromParticipationsWithCoverageOnDate(
          this.employee.allParticipations,
          this.$store.getters.policies,
          this.policyCoverageDate
        );
      } else return null;
    },
    policiesWithoutCoverage () {
      if (this.showPolicies) {
        return Compositions.getPoliciesFromParticipationsWithoutCoverageOnDate(
          this.employee.allParticipations,
          this.$store.getters.policies,
          this.policyCoverageDate
        ).map(p => p.product.description).join(', ');
      } else return null;
    }
  },
  methods: {
    getFormattedDate: date => Helpers.Dates.formatDate(date)
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';
.employee-card {
  padding: 20px 23px;
  position: relative;
  border: 1px solid $gray-lighten-1;
  border-radius: $border-radius;
  overflow: hidden;
}

.employee-card-divider-header {
  background-color: $gray-lighten-2;
  width: 100%;
  height: 53px;
  position: absolute;
  top: 0px;
  left: 0px;

}

.policies-container {
  background-color: $gray-lighten-2;
  padding: 20px 25px 25px 25px;
  border-bottom-left-radius: $border-radius;
  border-bottom-right-radius: $border-radius;
}

</style>
